import { render, staticRenderFns } from "./Marge.vue?vue&type=template&id=e36d85e6"
import script from "./Marge.vue?vue&type=script&lang=js"
export * from "./Marge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports